'use client'
import dynamic from 'next/dynamic'
import React from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperimentBucket } from '@src/experiments/statsig-integration'
import { Loader } from '@src/quince-components/src'
import { PageDataResponse } from '@src/server-side/api/api.types'

import styles from './my-orders-and-returns.module.scss'
const MyOrdersAndReturns = dynamic(() => import('./my-orders-and-returns'), {
  loading: () => (
    <div className={styles.loaderWrapper}>
      <Loader showLoader />
    </div>
  ),
})
const Orders = dynamic(() => import('../../../integrations/post-order-web/orders'), {
  loading: () => (
    <div className={styles.asyncLoaderWrapper}>
      <Loader showLoader />
    </div>
  ),
})

interface Props {
  data: PageDataResponse | null
  location: any
}

const OrdersPageTemplate = (props: Props) => {
  const orderDetailsBucket = useStatsigExperimentBucket(STATSIG_EXPERIMENTS.ORDER_DETAILS)
  const showBucket = orderDetailsBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.ORDER_DETAILS].buckets?.show
  // const [showBucket, setShowBucket] = useState<boolean | undefined>()

  // useEffect(() => {
  //   setShowBucket(orderDetailsBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.ORDER_DETAILS].buckets?.show)
  // }, [orderDetailsBucket])

  // if (showBucket === undefined) {
  //   return (
  //     <div className={styles.loaderWrapper}>
  //       <Loader showLoader />
  //     </div>
  //   )
  // }

  // @ts-expect-error Orders props type mismatch
  return showBucket ? <Orders {...props} /> : <MyOrdersAndReturns {...props} />
}

export default OrdersPageTemplate
